import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass([
        ])
}
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
          'mt-1'
        ])
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicHeadline = _resolveComponent("BasicHeadline")
  const _component_BasicImage = _resolveComponent("BasicImage")
  const _component_Blocks = _resolveComponent("Blocks")
  const _component_TreeSnippet = _resolveComponent("TreeSnippet")

  return (_openBlock(), _createElementBlock("div", {
    "tree-snippet": "",
    style: _normalizeStyle({paddingLeft: `${($props.depth -1)* 0.75}rem`}),
    class: _normalizeClass([
      ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BasicHeadline, {
        size: 'sm',
        text: `${$options.computedPrefix} ${$props.tree.name}`,
        class: _normalizeClass([
          ])
      }, null, 8, ["text"]),
      ($props.tree.thumbnail)
        ? (_openBlock(), _createBlock(_component_BasicImage, {
            key: 0,
            src: $props.tree.thumbnail,
            class: _normalizeClass([
          'max-w-32 max-h-32',
          'mt-1'
          ])
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    ($props.tree.wrapper === 'item')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Blocks, {
            content: $props.tree.render.content,
            class: _normalizeClass([
            'pl-5'
          ])
          }, null, 8, ["content"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tree.children, (c, key, index) => {
      return (_openBlock(), _createBlock(_component_TreeSnippet, {
        prefix: $options.computedPrefix,
        tree: c,
        key: key,
        depth: $props.depth + 1,
        index: index
      }, null, 8, ["prefix", "tree", "depth", "index"]))
    }), 128))
  ], 4))
}